'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const get = require('lodash.get');
const { Provider } = require('react-redux');
const { combineReducers, createStore, applyMiddleware } = require('redux');
const { track } = require('../../utils/chat').default;
const authModalLoader = require('../../utils/AuthModalLoader').default;
const MakeOfferRenderer = require('./MakeOfferRenderer').default;
const contactModal = require('../../contactModal/async').default;

const authProcess = authProps => {
    const {
        action,
        email,
        flow,
        ga
    } = authProps;
    return authModalLoader.show({
        action,
        email,
        flow: flow || authModalLoader.constants.CONTACT_DEALER_FLOW,
        ga
    });
};

export default (options) => {
    const modalContainer = document.createElement('div');
    const {
        item,
        linkLocation,
        currency,
        currentStep,
        preloadedState = {}
    } = options;

    let itemId;
    let sellerId;

    // If backbone model passed
    if (item && item.get) {
        itemId = item.get('id');
        sellerId = item.get('seller.id');
    } else {
        itemId = get(item, 'id') || get(item, 'serviceId');
        sellerId = get(item, 'seller.id') || get(item, 'seller.serviceId');
    }
    contactModal().then((mod) => {
        const {
            reducers,
            MakeOfferModal,
            LowBall,
            MakeOffer,
            AbandonMakeOfferModal,
            ModalWrapper,
            Confirmation,
            queries
        } = mod;

        const modalProps = {
            contactComponents: {
                MakeOfferModal,
                LowBall,
                MakeOffer,
                AbandonMakeOfferModal,
                ModalWrapper,
                Confirmation,
                queries
            },
            itemId,
            sellerId,
            chatTracking: track,
            pageCurrency: currency,
            linkLocation,
            startAuth: (authProps) => authProcess({...authProps, flow: authProps.makeOffer && authModalLoader.constants.CONTACT_DEALER_FORM_FLOW}),
            currentStep
        };

        const store = createStore(
            combineReducers(reducers),
            preloadedState,
            applyMiddleware(require('redux-thunk').default)
        );

        ReactDOM.render(
            <Provider store={ store }>
                <MakeOfferRenderer modalProps={modalProps} />
            </Provider>,
            modalContainer
        );
    });
};



// WEBPACK FOOTER //
// ./src/abandonedCheckout/components/makeOfferLauncher.jsx